import { TextBlock } from "../api/textBlockApi";
import { LanguageCode } from "../customers/customerlanguages";

export type TextBlockGroup = {
  source: TextBlock;
  translations: Partial<Record<LanguageCode, TextBlock>>;
};

export function groupTextBlocksBySource(
  textBlocks: TextBlock[]
): TextBlockGroup[] {
  const translated = textBlocks.filter((block) => block.translated_from);

  return textBlocks
    .filter((block) => !block.translated_from)
    .map((source) => ({
      source,
      translations: translated
        .filter((block) => block.translated_from === source.id)
        .reduce<Partial<Record<LanguageCode, TextBlock>>>(
          (byLanguage, block) => {
            byLanguage[block.language] = block;
            return byLanguage;
          },
          {}
        ),
    }));
}
